<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <h3 class="pb-1">Informationen</h3>
            <p><b>VertiHub - Einweisungs-App</b></p>
            <p>Version {{ version }}</p>
            <p>&copy; {{ year }} Mario Lauterbach. All rights reserved.</p>
        </div>
        <div class="col-md-8 pt-4">
        </div>
    </div>
</template>

<script>
import '../../node_modules/bootstrap-icons/font/bootstrap-icons.css'
import store from "../store"

export default {
  data () {
    return {
        year: new Date().getFullYear(),
        version: store.getters.appVersion
    }
  },
  created () {
  },
  methods: {
        }
}
</script>
